import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import memoize from 'memoizee';
import User from './User';
import { createIamAPI } from './API';
import env from '../misc/env';
import { reaction, action, runInAction, observable } from 'mobx';
var UserStore = (_dec = action.bound, _class = /*#__PURE__*/function (_Store) {
  function UserStore() {
    var _this;
    _classCallCheck(this, UserStore);
    _this = _callSuper(this, UserStore, arguments);
    _initializerDefineProperty(_this, "memberships", _descriptor, _this);
    _this.users = _this.collection({
      model: User,
      idAttribute: 'user_id',
      getModelId: function getModelId(data) {
        return data.user_id;
      }
    });
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    _this.rootStore.authStore.onLogout(action(function () {
      _this.users.clear();
    }));
    _this.rootStore.authStore.onLogin(function () {
      return _this.setupPresence();
    });
    _this.fetchWorkspaceMemberships = memoize(_this.fetchWorkspaceMemberships.bind(_this), {
      promise: true,
      length: 1
    });
    return _this;
  }
  _inherits(UserStore, _Store);
  return _createClass(UserStore, [{
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.users.get(id).then(this.users.set));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "fetchByPublicId",
    value: function () {
      var _fetchByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(publicId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.api.users.getByPublicId(publicId).then(this.users.set));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchByPublicId(_x2) {
        return _fetchByPublicId.apply(this, arguments);
      }
      return fetchByPublicId;
    }()
  }, {
    key: "authenticate",
    value: function () {
      var _authenticate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.api.auth.authenticate());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function authenticate() {
        return _authenticate.apply(this, arguments);
      }
      return authenticate;
    }()
  }, {
    key: "fetchWorkspaceMemberships",
    value: function () {
      var _fetchWorkspaceMemberships = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;
        var memberships;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.api.users.getUserWorkspaceMembershipsByPublicId(this.rootStore.authStore.user.public_id).then(function (memberships) {
                return memberships.map(function (m) {
                  return {
                    workspace: _this2.rootStore.workspaceStore.workspaces.set(m.workspace),
                    member: _this2.rootStore.memberStore.members.set(m.member)
                  };
                });
              });
            case 2:
              memberships = _context4.sent;
              runInAction(function () {
                _this2.memberships.replace(memberships);
              });
              return _context4.abrupt("return", this.memberships.slice());
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchWorkspaceMemberships() {
        return _fetchWorkspaceMemberships.apply(this, arguments);
      }
      return fetchWorkspaceMemberships;
    }()
  }, {
    key: "requestPasswordReset",
    value: function () {
      var _requestPasswordReset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(email, workspaceId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.api.users.requestPasswordReset(email, workspaceId));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function requestPasswordReset(_x3, _x4) {
        return _requestPasswordReset.apply(this, arguments);
      }
      return requestPasswordReset;
    }()
  }, {
    key: "getResetPasswordRequestById",
    value: function () {
      var _getResetPasswordRequestById = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.api.users.getResetPasswordRequestById(id));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getResetPasswordRequestById(_x5) {
        return _getResetPasswordRequestById.apply(this, arguments);
      }
      return getResetPasswordRequestById;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, password) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.api.users.resetPassword(id, password));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function resetPassword(_x6, _x7) {
        return _resetPassword.apply(this, arguments);
      }
      return resetPassword;
    }()
  }, {
    key: "addMembership",
    value: function addMembership(membership) {
      this.memberships.push(membership);
    }
  }, {
    key: "setupPresence",
    value: function () {
      var _setupPresence = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this3 = this;
        var messageStore;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              messageStore = this.rootStore.messageStore;
              if (!(!messageStore || !messageStore.api)) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return");
            case 3:
              // Whenever theres a change in the users array, make sure all added users get synced.
              reaction(function () {
                return _this3.users.map(function (user) {
                  return user;
                });
              }, function (users) {
                return users.map(/*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(user) {
                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) switch (_context8.prev = _context8.next) {
                        case 0:
                          if (!user.lastSynced || new Date().getTime() - user.lastSynced.getTime() > 60 * 1000) {
                            messageStore.enqueueOnlineStatusSync(user.public_id);
                          }
                        case 1:
                        case "end":
                          return _context8.stop();
                      }
                    }, _callee8);
                  }));
                  return function (_x8) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }, {
                fireImmediately: true
              });
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function setupPresence() {
        return _setupPresence.apply(this, arguments);
      }
      return setupPresence;
    }()
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "memberships", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "addMembership", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "addMembership"), _class.prototype), _class);
export { UserStore as default };
//# sourceMappingURL=UserStore.js.map
